import { ReactNode } from 'react';
import { Box } from '@bridebook/ui';
import { TInfoBlockItem } from '@bridebook/web/app-basic/components/supplier/sections/features/data-list';
import InfoRowV2 from '../info-row-v2/info-row-v2';
import componentStyles from './info-block-v2.style';

interface IProps {
  icon?: ReactNode;
  title?: ReactNode;
  items?: TInfoBlockItem[] | null;
}

const InfoBlockV2 = ({ icon, items, title }: IProps) => {
  const styles = componentStyles();

  return (
    <Box style={styles.wrapper}>
      {icon && <Box style={styles.iconWrapper}>{icon}</Box>}
      <Box style={styles.contentWrapper}>
        {title && <Box style={styles.title}>{title}</Box>}
        {items && (
          <Box style={styles.itemsWrapper}>
            {items.map(({ label, key, formattedValue }) => (
              <InfoRowV2 key={`info-row-${key}`} title={label} amount={formattedValue} />
            ))}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default InfoBlockV2;
